import type { Condition } from "@medplum/fhirtypes";
import { CONDITION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useConditionSubscription = createSubscriptionHook<Condition>("Condition", CONDITION_COLLECTION_NAME);
